<template>
	<div class="card-table">
		<div class="header">
			<div class="title">{{title}}</div>
			<div class="more">查看更多</div>
		</div>
		<div class="main">
			<slot></slot>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'cardTable',
		props: {
			title: {
				type: String
			},
			isSmall: {
				type: Boolean
			}
		}
	}
</script>
<style lang="scss" scoped>
	@import '../../../docs/scss/variables';
	.card-table {
		width: 570px;
		background: #fff;
		
		border-radius: 4px;
		.header {
			color: $font-dark;
			display: flex;
			justify-content: space-between;
			background: #f2f2f2;
			padding: 10px 15px;
			border-radius: 4px 4px 0 0;
		}
		.main {
			padding: 10px 15px;
		}
		&.small {
			width: 300px;
		}
		.row {
			color: $font-light;
			display: flex;
			box-sizing: border-box;
			line-height: 36px;
			transition: all .25s;
			text-align: left;
			div { box-sizing: border-box; }
			&:not(:last-child) { @include border-bottom(); }
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/cardTable/cardTable.vue